import { minutesToHoursAndMinutes } from "../../../../common/helpers/time";
import { isJson } from "../../../../common/helpers/json";
function AdminSettingsPoliciesCoursesController(
  UserService,
  $state,
  UsersModel,
  PoliciesModel,
  PoliciesStoreService,
  FlashService,
  CourseTypesModel,
) {
  const vm = this;
  vm.formData = {};
  const currentUser = UserService.getCurrentUser();
  vm.formData.policymeta = {};
  vm.minSessionLength = {};
  vm.processPolicy = processPolicy;

  init();

  function init() {
    vm.school = currentUser.school;
    vm.policies = { courses: { id: 0, policymeta: {} } };

    const coursesPolicy = PoliciesStoreService.getPolicy("courses");
    if (coursesPolicy) {
      const policyMeta = {};
      Object.keys(coursesPolicy.policymeta).forEach((key) => {
        const value = coursesPolicy.policymeta[key];
        policyMeta[key] = isJson(value) ? JSON.parse(value) : value;
      });

      if (!policyMeta.hasOwnProperty("allow_add_student_to_course")) {
        policyMeta.allow_add_student_to_course = "Y";
      }

      if (
        !policyMeta.hasOwnProperty(
          "require_student_signature_on_class_attendance",
        )
      ) {
        policyMeta.require_student_signature_on_class_attendance = "N";
      }

      if (policyMeta.hasOwnProperty("class_reminder_buffer")) {
        policyMeta.class_reminder_buffer = String(
          policyMeta.class_reminder_buffer,
        );
      } else {
        policyMeta.class_reminder_buffer = "72";
      }

      if (policyMeta.hasOwnProperty("minimum_session_length")) {
        const dur = minutesToHoursAndMinutes(policyMeta.minimum_session_length);
        vm.minSessionLength.hours = dur.hours;
        vm.minSessionLength.minutes = dur.minutes;
      }

      policyMeta.id = coursesPolicy.id;
      vm.policies.courses = { id: coursesPolicy.id, policymeta: policyMeta };
    }
  }

  function processPolicy(isValid) {
    vm.policies.courses.policymeta.minimum_session_length =
      parseInt(vm.minSessionLength.hours, 10) * 60 +
      parseInt(vm.minSessionLength.minutes, 10);

    if (isValid) {
      const payload = vm.policies.courses.policymeta;
      PoliciesModel.update(payload).then(function (response) {
        FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        PoliciesStoreService.writePolicy("courses", payload);
      });
    } else {
      FlashService.setMessage({
        type: "error",
        message: "All fields are required.",
      });
    }
  }
}
AdminSettingsPoliciesCoursesController.$inject = [
  "UserService",
  "$state",
  "UsersModel",
  "PoliciesModel",
  "PoliciesStoreService",
  "FlashService",
  "CourseTypesModel",
];

export default AdminSettingsPoliciesCoursesController;
